import { fetchLeadListApi, updateLeadApi } from "services/leadService";
import {
  fetchSingleLeadData,
  fetchLeadData,
  setPagination,
  setLeadLoader,
  leadSuccessMsg,
  leadErrorMsg,
} from "./reducer";

export const fetchLeads = (data: any) => async (dispatch: any) => {
  dispatch(setLeadLoader(true));
  try {
    const response = await fetchLeadListApi(data);
    if (response.success) {
      if (data.lead_id && data.lead_id !== 0) {
        dispatch(fetchSingleLeadData(response));
        dispatch(setPagination(response.data.pagination));
      } else {
        dispatch(fetchLeadData(response));
        dispatch(setPagination(response.data.pagination));
      }
    }
  } catch (fetchLeadError: any) {
    const errorMessage =
      fetchLeadError?.message ||
      fetchLeadError?.response?.data?.message ||
      "Something went wrong";
    dispatch(leadErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setLeadLoader(false));
  }
};

export const updateLeadStatus = (
  lead_id: number,
  updateData: { status: string; note: string }
) => async (dispatch: any) => {
  dispatch(setLeadLoader(true));
  try {
    const response = await updateLeadApi(lead_id, updateData);
    if (response.success) {
      dispatch(
        leadSuccessMsg({
          message: response.message || "Lead updated successfully",
          id: Date.now(),
        })
      );
      // Optionally refetch leads after update
      // dispatch(fetchLeads({ page: 1, per_page: 10, from_date: '', to_date: '', status: '', lead_id: 0 }));
    } else {
      dispatch(
        leadErrorMsg({
          message: response.message || "Failed to update lead",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong";
    dispatch(leadErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setLeadLoader(false));
  }
};
